import './register.css';
import { useState } from 'react';
import { Header } from '../../components/header/Header';
import { BarLoader } from '../../components/BarLoader/BarLoader';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';
import { useAuth } from '../../context/AuthContext';

export function Register() {
    //HOOKS
    const { lang } = useLang();
    const { postRequest } = useServer();
    const navigate = useNavigate();
    const { checkAuth } = useAuth();

    //STATES
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState("");

    //FUNCTIONS
    const register = () => {
        if (loading) {
            return;
        }

        if (pwd !== pwd2) {
            setErrorMsg(lang === "en" ? "The passwords do not match" : "Las contraseñas no coinciden");
            return;
        }

        setLoading(true);
        setErrorMsg("");

        let data = {
            name: name,
            email: email,
            password: pwd,
        };

        postRequest(endpoints.register, data, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];
                if (res.success) {
                    checkAuth();
                    navigate('/courses', {replace: true});
                } else {
                    if (res.error === "email_used") {
                        setErrorMsg(lang === "en" ? "The email is already registered" : "El correo ya se encuentra registrado");
                    }

                    if (res.error === "required_fields") {
                        setErrorMsg(lang === "en" ? "All fields are required" : "Todos los campos son requeridos");
                    }
                }
            } else {
                setErrorMsg(lang === "en" ? "Server error, please try again in a bit": "Error del servidor, intenta de nuevo en un momento");
            }
        });
    }

    return (
        <>
            <Header />
            <div className='register_form_body'>
                <div className='form'>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Email": "Correo electrónico" }
                        </label>
                        <input type='text' placeholder={ lang === "en" ? "Email": "Correo electrónico" } value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Name" : "Nombre"}
                        </label>
                        <input type='text' placeholder={ lang === "en" ? "Name" : "Nombre"} value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Password" : "Contraseña" }
                        </label>
                        <input type='password' placeholder={ lang === "en" ? "Password" : "Contraseña" } value={pwd} onChange={(e) => setPwd(e.target.value)} />
                    </div>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Repeat the password" : "Repite la contraseña" }
                        </label>
                        <input type='password' placeholder={ lang === "en" ? "Repeat the password" : "Repite la contraseña" } value={pwd2} onChange={(e) => setPwd2(e.target.value)} />
                    </div>
                    {errorMsg !== "" && 
                        (
                            <div className='error_msg'>
                                {errorMsg}
                            </div>
                        )
                    }
                    <button onClick={register}>
                        { lang === "en" ? "Sign up" : "Registrarse"}
                    </button>

                    {loading && 
                        (
                            <div className='loader'>
                                <BarLoader />
                            </div>
                        )
                    }
                    <Link to='/register'>
                        { lang === "en" ? (
                            <>
                                Already have an account? <Link to='/login'>Login</Link>
                            </>
                        ) : (
                            <>
                                ¿Ya tienes una cuenta? <Link to='/login'>Inicia sesión</Link>
                            </>
                        )}
                    </Link>
                    <Link to='/forgot'>
                        { lang === "en" ? "Forgot your password?" : "¿Olvidaste tu contraseña?" }
                    </Link>
                </div>
            </div>
        </>
    );
}